import actions from '@/core/store/pedido/documento/actions'

export default {
	actions,
}
